import * as Sentry from "@sentry/react";
import { env } from "../config";

export enum SentryEnv {
    LOCAL = "local",
    DEV = "development",
    STAGE = "stage",
    PROD = "production"
}

const getSentryEnv = () => {
    if (env === "local") {
        return SentryEnv.LOCAL;
    } else if (env === "dev") {
        return SentryEnv.DEV;
    } else if (env === "stage") {
        return SentryEnv.STAGE;
    }
    return SentryEnv.PROD;
};


const getSessionSampleRateByEnv = (sentryEnv: SentryEnv) => {
    if (sentryEnv === SentryEnv.STAGE) {
        return 0.75;
    }
    else if (sentryEnv === SentryEnv.PROD) {
        return 0.05;
    }
    return 1.0;
};

const sentryEnv = getSentryEnv();

const sessionSampleRate = getSessionSampleRateByEnv(sentryEnv);
let sentryClient;
if (sentryEnv === SentryEnv.LOCAL) {
    // don't initialize sentry in local environment
    sentryClient = null;
}
else {
    sentryClient = Sentry.init({
        dsn: "https://88d3fd33cc647520dd06c4dc6ca3946f@o4504501031403520.ingest.us.sentry.io/4508830091116545",
        integrations: [
            Sentry.browserTracingIntegration(),
            Sentry.replayIntegration(),
        ],
        // Tracing
        tracesSampleRate: sessionSampleRate,
        // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
        tracePropagationTargets: [
            "https://dash-safedk-new.dev-applovin.com",
            "https://stage-dash-safedk.applovin.com",
            "https://prod-dash.safedk.applovin.com"
        ],

        // Session Replay
        replaysSessionSampleRate: sessionSampleRate, // Set the sample rate differently for each environment
        replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
        environment: sentryEnv
    });
}

export default sentryClient;